import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot"]
  static classes = ["highlighted"]

  highlightSlot(event) {
    const dayStr = event.params.day?.toString() || -1
    const timeStr = event.params.time?.toString() || -1
    const hoveredGrid = event.currentTarget.dataset.scheduleGrid

    this.slotTargets.forEach(slot => {
      const slotDay = slot.dataset.calendarHoverHighlightDayParam
      const slotTime = slot.dataset.calendarHoverHighlightTimeParam
      const slotGrid = slot.dataset.scheduleGrid

      // Time matching: always highlight (time gutter is shared)
      const timeMatches = timeStr !== "-1" && slotTime === timeStr
      
      // Day matching: only highlight if in the same grid
      // If hovering over time gutter (no grid), don't highlight by day
      const dayMatches = dayStr !== "-1" && slotDay === dayStr && 
                         hoveredGrid && slotGrid && hoveredGrid === slotGrid

      if(timeMatches || dayMatches) {
        slot.classList.add(this.highlightedClass)
      } else {
        slot.classList.remove(this.highlightedClass)
      }
    })

  }

  clearHighlight() {
    this.slotTargets.forEach(slot => {
      slot.classList.remove(this.highlightedClass)
    })
  }
}